import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Icon } from 'Components/UI'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

import pathCornerBLGlyph from './pathCornerBL.svg'
import pathCornerBRGlyph from './pathCornerBR.svg'
import pathCornerTLGlyph from './pathCornerTL.svg'
import pathCornerTRGlyph from './pathCornerTR.svg'
import pathHorizontalGlyph from './pathH.svg'
import pathVerticalGlyph from './pathV.svg'
import pathVerticalLongGlyph from './pathVertLong.svg'
import pointGlyph from './point.svg'

const strokeCss = css`
  stroke: ${themeGet('colors.calculator.action')};
  stroke-dasharray: 8 8;
  stroke-width: 1;
`

const height = 70

export const PathHorizontal = styled(Icon).attrs({
  glyph: pathHorizontalGlyph,
  height,
  width: 800,
})`
  ${strokeCss}
`

export const Point = styled(Icon).attrs({
  glyph: pointGlyph,
  size: 16,
  top: [6, 8],
  left: [0 - LANDING_INLINE_PADDINGS[0], 0],
})`
  stroke: ${themeGet('colors.calculator.action')};
  stroke-width: 5px;
  fill: ${themeGet('colors.white')};
  z-index: 10;
  position: absolute;
  transform: translateX(-50%);
`

const Corner = styled(Icon).attrs({
  height,
  width: 30,
})`
  ${strokeCss}
`

export const PathCornerTL = styled(Corner).attrs({
  glyph: pathCornerTLGlyph,
})``

export const PathCornerBR = styled(Corner).attrs({
  glyph: pathCornerBRGlyph,
})``

export const PathCornerBL = styled(Corner).attrs({
  glyph: pathCornerBLGlyph,
})``

export const PathCornerTR = styled(Corner).attrs({
  glyph: pathCornerTRGlyph,
})``

const shiftCss = ({ shift }) =>
  shift &&
  css`
    left: -1px;
  `

export const PathVertical = styled(Icon).attrs({
  glyph: pathVerticalGlyph,
})`
  width: 2px;
  height: 500px;
  position: absolute;
  top: 0;
  left: 0;

  ${strokeCss}

  ${shiftCss}
`

export const PathVerticalLong = styled(Icon).attrs({
  glyph: pathVerticalLongGlyph,
})`
  width: 2px;
  height: 1500px;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 1;

  ${strokeCss};
`
